<template>
  <div class="panel-loader">
    <div class="panel-loader__loading-dot">
      <span class="panel-loader__loading-dot-center"></span>
    </div>
    <p>{{ $t('twitch.sendingRequest') }}</p>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import VoiceRepository from '@/service/repository/voice';
import ConfigurationRepository from '@/service/repository/configuration';

export default {
    data() {
        return {
            loaderTime: 5000, // PM request to show the loader animation
            responseStatus: 200,
        };
    },

    computed: {
        ...mapGetters('panel', ['get_panelVoiceSelected']),
        ...mapState({
            twitchUserId: state => state.global.twitchUserId,
            twitchAuthToken: state => state.global.twitchAuthToken,
            twitchChannelId: state => state.global.twitchChannelId,
        }),

        voice() {
            return this.get_panelVoiceSelected(this.$route.params.id);
        },

        voiceId() {
            return this.voice.voiceId;
        },

        voiceVersion() {
            return this.voice.version;
        },
    },

    mounted() {
        this.sendVoiceChangeRequest();
    },

    methods: {
        ...mapActions({
            axn_purchasedVoices: 'panel/axn_purchasedVoices',
        }),

        sendVoiceChangeRequest() {
            ConfigurationRepository.isVoiceChangeAvailable(
                this.twitchAuthToken,
                this.twitchChannelId,
                this.voiceId,
            ).then(() => {
                const { price } = this.$route.params;

                price === 0 ? this.changeVoiceFree() : this.bitsTransaction(price);
            }).catch((error) => {
                this.responseStatus = error.response.status;
                this.pushToErrorView();
            });
        },

        bitsTransaction(price) {
            this.$twitch.bits.getProducts().then(product => {
                const vmProduct = product.find(_ => _.sku === `vm${price}bits`);

                if (!vmProduct || !product) {
                    setTimeout(() => {
                        this.pushToErrorView();
                    }, this.loaderTime);
                }

                this.$twitch.bits.useBits(vmProduct.sku);

                this.$twitch.bits.onTransactionCancelled(() => {
                    this.pushToErrorView();
                });

                this.$twitch.bits.onTransactionComplete((transactionObject) => {
                    this.changeVoice(transactionObject);
                });
            });
        },

        changeVoice(transactionObject) {
            const { price, time } = this.$route.params;
            const { transactionId, transactionReceipt } = transactionObject;

            VoiceRepository.changeVoice(
                transactionReceipt,
                transactionId,
                this.voiceId,
                this.twitchChannelId,
                time,
                price,
                this.voiceVersion,
            )
                .then((response) => {
                    this.responseStatus = response.status;
                    response.status === 200 ? this.pushToSuccessView() : this.pushToErrorView();
                })
                .catch((error) => {
                    this.responseStatus = error.response.status;

                    this.pushToErrorView();
                });
        },

        changeVoiceFree() {
            const { price, time } = this.$route.params;

            VoiceRepository.changeFreeVoice(
                this.twitchAuthToken,
                this.voiceId,
                this.twitchChannelId,
                time,
                price,
                this.voiceVersion,
            )
                .then((response) => {
                    this.responseStatus = response.status;

                    setTimeout(() => {
                        this.addToPurchasedVoice(response.data._expireAt);

                        response.status === 200 ? this.pushToSuccessView() : this.pushToErrorView();
                    }, this.loaderTime);
                })
                .catch((error) => {
                    this.responseStatus = error.response.status;

                    if (this.responseStatus === 429) {
                        this.addToPurchasedVoice(error.response.data.expireAt);
                    }

                    this.pushToErrorView();
                });
        },

        pushToErrorView() {
            const { id, time, price } = this.$route.params;

            this.$router.push({ name: 'PanelError', params: { id, time, price, responseStatus: this.responseStatus } });
        },

        pushToSuccessView() {
            this.$router.push({ name: 'PanelSuccess' });
        },

        addToPurchasedVoice(expireAt) {
            this.axn_purchasedVoices(
                {
                    twitchChannelId: this.twitchChannelId,
                    id: this.voice.id,
                    voiceId: this.voiceId,
                    expireAt,
                },
            );
        },
    },
};
</script>

<style src="./PanelLoader.scss" lang="scss" scoped></style>
